import { render } from "./NavCategoryScroll.vue?vue&type=template&id=da35e04e&scoped=true"
import script from "./NavCategoryScroll.vue?vue&type=script&lang=js"
export * from "./NavCategoryScroll.vue?vue&type=script&lang=js"

import "./NavCategoryScroll.vue?vue&type=style&index=0&id=da35e04e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da35e04e"]])

export default __exports__